<!--
  ChannelIcon — one modern line/glyph icon per credit channel (sms | email | ai),
  drawn entirely in `currentColor` so it reads correctly BOTH as an accent-coloured
  glyph on a light surface (the header pill) AND as a white glyph inside a coloured
  gradient tile (the My Account → Credits rows). Shared by CreditBalancePill.vue and
  SmsCreditsTab.vue so the channel iconography never drifts between the two surfaces.

  Usage: <ChannelIcon channel="email" class="ci" />  (size/colour come from the caller's CSS)
-->
<template functional>
  <svg
    :class="['channel-icon', data.staticClass, data.class]"
    :style="[data.staticStyle, data.style]"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <!-- SMS — rounded chat bubble with three dots -->
    <template v-if="props.channel === 'sms'">
      <path
        d="M4.5 6.6A2.6 2.6 0 0 1 7.1 4h9.8a2.6 2.6 0 0 1 2.6 2.6v6a2.6 2.6 0 0 1-2.6 2.6H9.4l-3.5 2.8c-.5.4-1.4.05-1.4-.62V6.6Z"
        stroke="currentColor"
        stroke-width="1.7"
        stroke-linejoin="round"
      />
      <circle cx="8.6" cy="9.5" r="0.95" fill="currentColor" />
      <circle cx="12" cy="9.5" r="0.95" fill="currentColor" />
      <circle cx="15.4" cy="9.5" r="0.95" fill="currentColor" />
    </template>

    <!-- Email — rounded envelope with a flap line -->
    <template v-else-if="props.channel === 'email'">
      <rect x="3.4" y="5.4" width="17.2" height="13.2" rx="2.6" stroke="currentColor" stroke-width="1.7" />
      <path
        d="M4.6 7.7l6.3 4.25c.66.44 1.54.44 2.2 0L19.4 7.7"
        stroke="currentColor"
        stroke-width="1.7"
        stroke-linecap="round"
      />
    </template>

    <!-- AI — sparkle (reserved for the future AI credits channel) -->
    <template v-else-if="props.channel === 'ai'">
      <path
        d="M12 3.4l1.65 4.35 4.35 1.65-4.35 1.65L12 15.4l-1.65-4.35L6 9.4l4.35-1.65L12 3.4Z"
        fill="currentColor"
      />
      <path
        d="M18.4 13.6l.72 1.9 1.9.72-1.9.72-.72 1.9-.72-1.9-1.9-.72 1.9-.72.72-1.9Z"
        fill="currentColor"
        opacity="0.6"
      />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'ChannelIcon',
  props: {
    // 'sms' | 'email' | 'ai'
    channel: { type: String, required: true },
  },
};
</script>

<style scoped>
.channel-icon {
  width: 1em;
  height: 1em;
  display: inline-block;
  vertical-align: -0.14em;
  flex: none;
}
</style>
